import { Grid, Paper } from '@mantine/core';
import { ModulesSettingsForm } from './Forms/ModulesSettingsForm';

export const GroupSettingsModules = () => {
  return (
    <Grid gutter={'lg'}>
      <Grid.Col span={6}>
        <Paper radius={'md'} p={'md'} withBorder>
          <ModulesSettingsForm />
        </Paper>
      </Grid.Col>
    </Grid>
  );
};
